import api from '../utils/API';

export const cepService = async cep =>
  api({
    url: `https://kj5goodoq9.execute-api.us-east-1.amazonaws.com/viacep/${cep}`,
    method: 'GET',
  }).then(resp => resp);
